import React from "react";
import "./Logos.css";
import ADVANCELogo from "./images/logos/ADVANCE.svg";
import IEEELogo from "./images/logos/IEEE.jpg";
import UCCLlogo from "./images/logos/UCC.png";
import MTULogo from "./images/logos/MTU.jpg";
import MSTLogo from "./images/logos/Missouri.jpg";

const Logos = () => {
  const logos = [
    {
      name: "IEEE",
      logo: IEEELogo,
      url: "https://www.ieee.org/",
    },
    {
      name: "ADVANCE CRT",
      logo: ADVANCELogo,
      url: "https://www.advance-crt.ie/",
    },
    {
      name: "UCC",
      logo: UCCLlogo,
      url: "https://www.ucc.ie/",
    },
    {
      name: "MTU",
      logo: MTULogo,
      url: "https://www.mtu.ie/",
    },
    {
      name: "MST",
      logo: MSTLogo,
      url: "https://www.mst.edu/",
    },
  ];

  return (
    <div className="logo-container">
      {logos.map(function (data) {
        {
          console.log(data.logo);
        }

        return (
          <a href={data.url}>
            <img className="logo-image" src={data.logo} />
          </a>
        );
      })}
    </div>
  );
};

export default Logos;
